import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface/index.ts';
import { AOAIFilterConfig } from './filters/AOAIFilterConfig';

export const AOAITenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.AOAICapacity], //AOAI Capacity
  provider: TenantProvider.ADO,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: true,
    SensitiveInfoErrorCount: false,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: AOAIFilterConfig,
      AreaPath: [UATConstants.AOAI_DefaultValue_AreaPath],
      Title: UATConstants.TenantTitles.AzureAOAI,
      ADOTitle: UATConstants.TenantADOText.AOAI,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateAOAIRequest,
          Key: UATConstants.CreateActionMenuKey.CreateAOAIRequest,
          NodeName: '',
        },
      ],
      hideCreateButton: false,
      BulkUpload: true,
      DownloadTemplate: true,
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DownloadTemplateConfig: {
        tenantToolName: 'aoai',
        title: UATConstants.PlaceholdersAndTitles.AOAIAssignedTeam,
        excelColumnSequence: {
          'ID': 1,
          'Title': 2,
          'Action Owner': 3,
          'Assigned Team': 4,
          'AOAI_RequestType': 5,
          'AOAI_RequestUrgency': 6,
          'AOAI_UOM': 7,
          'AOAI_Amount': 8,
          'AOAI_ApprovedPreferredRegion': 9,
          'AOAI_Decision': 10,
          'AOAI_DateDecided': 11,
          'Contributors': 12,
        },
      },
      RelatedItem: true,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        {
          formFieldName: 'assignedTo',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner,
          apiFieldName: 'assignedTo',
        },
        {
          formFieldName: 'requestor',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.Requestor,
          apiFieldName: 'requestor',
        },
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: false,
          Email: false,
          CopyLink: false,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: true,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: false,
          DiscussionInsights: false,
        },
        StatusUpdate: false,
        ClosureStatement: false,
        Discussion: false,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      isArtemisIntegrationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: false,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      dropdownValues: {},
    },
  },
};
// Generated by GitHub Copilot | Updated on: 2026-07-02 | 1 lines modified | Added AOAI_RequestUrgency to export column sequence (WI #138509)
// Generated by GitHub Copilot | Updated on: 2026-07-08 | 1 line added | Added AOAI_UOM to export column sequence (WI #138593)
// Generated by GitHub Copilot | Updated on: 2026-10-12 | 1 line added | Ordered shared Contributors template column
